import { useMemo } from 'react';
import { useSelector } from 'react-redux';

import { InputType } from 'interfaces/IInput';

import { RootState } from '../../redux/Store';

import { useFetchInputsByOrgId } from './useFetchInputsByOrgId';

/**
 * The currently selected input document — joins the selected id (Redux,
 * InputSlice) against the active organisation's inputs (React Query,
 * useFetchInputsByOrgId), the same join OrganisationWorkspace already makes
 * for its own use. Reads from the same query cache OrganisationWorkspace
 * already warms, so calling this elsewhere costs no extra request.
 */
export const useSelectedInput = () => {
  const selectedInputId = useSelector(
    (state: RootState) => state.inputReducer.selectedInputId
  );
  const activeOrganisationId = useSelector(
    (state: RootState) => state.activeOrganisationReducer.organisationId
  );
  const { data: inputs = [] } = useFetchInputsByOrgId(
    activeOrganisationId,
    InputType.PlanActual
  );

  return useMemo(
    () => inputs.find((input) => input.id === selectedInputId),
    [inputs, selectedInputId]
  );
};
